import React from "react";
import { TwConfirmDialog } from "./tailwind";


export default function MarkAsPaidDialog({ open, handleClose, onSubmit }) {
  return (
    <TwConfirmDialog
      dialogOpen={open}
      dialogType="warning"
      dialogTitle="WARNING"
      dialogMessage={"Payment status cannot be changed back to unpaid. Are you sure you want to change status to paid?"}
      onClose={handleClose}
      onConfirm={onSubmit}
    />
  )
}
